import { RootState } from 'app/rootReducer'

export const isLoadingSelector = (state: RootState) => state.user.meta.isLoading
export const errorSelector = (state: RootState) => state.user.meta.error
export const userSelector = (state: RootState) => ({
  name: state.user?.name,
  email: state.user?.email,
  logo: state.user?.logo,
})
